export default "__VITE_ASSET__JJjCLe_t__"